module.exports = __webpack_public_path__ + "img/tu03.0cb23961.jpg";